exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".list-result{width:40%!important}.list-result .el-select-dropdown__wrap{max-height:360px!important}.list-result .el-select-dropdown__list{padding:0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-5af589b6","scoped":false,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=1!./resources/js/components/items/ItemSearchQuickSale.vue
// module id = UNp4
// module chunks = 0